var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-data-table",
    _vm._g(
      _vm._b(
        {
          class: _vm.tableClass,
          attrs: {
            headers: _vm.headers,
            items: _vm.items,
            options: _vm.options,
            "hide-default-footer": "",
          },
          on: {
            "update:options": function ($event) {
              _vm.options = $event
            },
          },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$slots, function (_, name) {
                return {
                  key: name,
                  fn: function () {
                    return [_vm._t(name)]
                  },
                  proxy: true,
                }
              }),
              _vm._l(_vm.$scopedSlots, function (_, scopedName) {
                return {
                  key: scopedName,
                  fn: function (slotData) {
                    return [_vm._t(scopedName, null, null, slotData)]
                  },
                }
              }),
              {
                key: "footer",
                fn: function () {
                  return [
                    _vm.pageCount > 1
                      ? _c("v-pagination", {
                          attrs: {
                            length: _vm.pageCount,
                            "total-visible": _vm.totalVisible,
                          },
                          model: {
                            value: _vm.options.page,
                            callback: function ($$v) {
                              _vm.$set(_vm.options, "page", $$v)
                            },
                            expression: "options.page",
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "v-data-table",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }